{
  "Baslik": "Elementer Sigortalar",
  "elementer": {
    "Baslik": "Elementer Sigortalar",
    "Yeni Ekle": "Elementer Sigorta Ekle",
    "Ekle": "Ekle",
    "Düzenle": "Elementer Sigorta Düzenle",
    "Genel Bilgiler": "Genel Bilgiler",
    "Dosyalar": "Dosyalar",
    "Müşteri": "Müşteri",
    "Sigorta Türü": "Sigorta Türü",
    "Başlangıç Tarihi": "Başlangıç Tarihi",
    "Bitiş Tarihi": "Bitiş Tarihi",
    "Sigorta Şirketi": "Sigorta Şirketi",
    "Şirket adı seçin veya yazın...": "Şirket adı seçin veya yazın...",
    "Poliçe No": "Poliçe No",
    "Poliçe numarası": "Poliçe numarası",
    "Tutar": "Tutar (₺)",
    "UAVT Kodu": "UAVT Kodu",
    "Adres Kodu": "Adres Kodu",
    "Araç Marka Model": "Araç Marka Model",
    "Örn: 34 ABC 123 - Ford Focus": "Örn: 34 ABC 123 - Ford Focus",
    "Daini Mürtehin": "Daini Mürtehin",
    "Banka / Finans kurumu yazın...": "Banka / Finans kurumu yazın...",
    "Adres": "Adres",
    "Açık Adres Bilgisi": "Açık Adres Bilgisi",
    "Gidiş Amacı": "Gidiş Amacı",
    "Örn: Turistik / İş Gezisi": "Örn: Turistik / İş Gezisi",
    "Ülke": "Hangi Ülke",
    "Örn: Almanya, Fransa": "Örn: Almanya, Fransa",
    "Açıklama": "Açıklama",
    "Ek notlar ve açıklamalar...": "Ek notlar ve açıklamalar...",
    "Takip": "Takip Edilsin",
    "Takip Ediliyor": "Takip Ediliyor",
    "Takip Edilmiyor": "Takip Edilmiyor",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "Kalan Gün": "Kalan Gün",
    "Gün": "Gün",
    "Gün Geçti": "Gün Geçti",
    "Gün Kaldı": "Gün Kaldı",
    "Bugün Bitiyor": "Bugün Bitiyor",
    "Süresi Doldu": "Süresi Doldu",
    "Kopyasını Oluştur": "Kopyasını Oluştur",
    "Dosya Seç": "Dosya Seç (Foto / PDF)",
    "Dosya Seç (Çoklu seçebilirsiniz)": "Dosya Seç (Çoklu seçebilirsiniz)",
    "Yeni Fotoğraf veya PDF Yükle": "Yeni Fotoğraf veya PDF Yükle",
    "Örn: Poliçe örneği, Kimlik fotokopisi vb.": "Örn: Poliçe örneği, Kimlik fotokopisi vb.",
    "Yüklü Dosyalar Listesi": "Yüklü Dosyalar Listesi",
    "Henüz yüklü dosya bulunmuyor": "Henüz yüklü dosya bulunmuyor.",
    "Açıklama ekleyin...": "Açıklama ekleyin...",
    "Açıklamayı Kaydet": "Açıklamayı Kaydet",
    "Görüntüle": "Görüntüle",
    "Poliçe no, şirket, UAVT vb. ara...": "Poliçe no, şirket, UAVT vb. ara...",
    "Takip Listesi": "Elementer Sigorta Takip Listesi",
    "Tümünü Gör": "Tümünü Gör",
    "Takip Alt Başlık": "Süresi dolan ve bitiş tarihine 15 gün kalan takipteki poliçeler",
    "Poliçeyi İncele": "Poliçeyi İncele",
    "Tür": "Tür",
    "Dosya Açıklaması": "Dosya Açıklaması",
    "Tutar 0'dan büyük olmalıdır": "Tutar 0'dan büyük olmalıdır",
    "Yükle": "Yükle",
    "Durum": "Durum",
    "İşlem": "İşlem",
    "Hepsi": "Hepsi",
    "Filtrele": "Filtrele",
    "Filtreleri Temizle": "Filtreleri Temizle",
    "Data Yenile": "Data Yenile",
    "Excel": "Excel",
    "Kaydet": "Kaydet",
    "Güncelle": "Güncelle",
    "İptal": "İptal",
    "Sil": "Sil",
    "Silme Onayı": "Silme Onayı",
    "Bu kaydı silmek istediğinize emin misiniz?": "Bu kaydı silmek istediğinize emin misiniz?",
    "Kayıt silindi": "Kayıt silindi",
    "İşlem başarısız": "İşlem başarısız",
    "Veriler yüklenemedi": "Veriler yüklenemedi",
    "Dask": "DASK",
    "Kasko": "Kasko",
    "Trafik": "Trafik",
    "Konut": "Konut",
    "İş Yeri": "İş Yeri",
    "Seyahat": "Seyahat",
    "Tamamlayıcı Sağlık": "Tamamlayıcı Sağlık",
    "Özel Sağlık": "Özel Sağlık"
  }
}
